const QTY_EPSILON = 0.0001;

function scheduleCoversQuantity(schedule) {
  const note = schedule && schedule.delivery_note;
  if (note && note.id) {
    return note.status !== "cancelled";
  }
  return Boolean(schedule && schedule.is_assigned);
}

export function orderLineNeedsDeliveryNote(line) {
  const ordered = Number(line && line.ordered_quantity ? line.ordered_quantity : 0);
  if (ordered <= QTY_EPSILON) {
    return false;
  }

  const schedules = Array.isArray(line && line.schedules) ? line.schedules : [];
  if (!schedules.length) {
    return true;
  }

  const covered = schedules.reduce((sum, schedule) => {
    if (!scheduleCoversQuantity(schedule)) {
      return sum;
    }
    return sum + Number(schedule.quantity || 0);
  }, 0);

  return covered + QTY_EPSILON < ordered;
}

export function orderHasUnplannedDelivery(lines) {
  return (lines || []).some((line) => orderLineNeedsDeliveryNote(line));
}

export function deliveryNoteCanJoinTransport(note) {
  if (!note || !["draft", "confirmed"].includes(note.status)) {
    return false;
  }
  const transportStatus = note.transport_order && note.transport_order.status;
  return !note.stock_transport_order_id || transportStatus === "cancelled";
}

export function orderHasTransportToOrganize(notes) {
  return (notes || []).some((note) => deliveryNoteCanJoinTransport(note));
}
